__turbopack_context__.v({
  "description": "nav-addon-spheres-module__7rU83q__description",
  "explore": "nav-addon-spheres-module__7rU83q__explore",
  "headerTitle": "nav-addon-spheres-module__7rU83q__headerTitle",
  "item": "nav-addon-spheres-module__7rU83q__item",
  "ktalk": "nav-addon-spheres-module__7rU83q__ktalk",
  "listen": "nav-addon-spheres-module__7rU83q__listen",
  "pause": "nav-addon-spheres-module__7rU83q__pause",
  "pauseBar": "nav-addon-spheres-module__7rU83q__pauseBar",
  "pillSm": "nav-addon-spheres-module__7rU83q__pillSm",
  "pillSmLabel": "nav-addon-spheres-module__7rU83q__pillSmLabel",
  "play": "nav-addon-spheres-module__7rU83q__play",
  "plusBarHSm": "nav-addon-spheres-module__7rU83q__plusBarHSm",
  "plusBarVSm": "nav-addon-spheres-module__7rU83q__plusBarVSm",
  "plusSm": "nav-addon-spheres-module__7rU83q__plusSm",
  "product": "nav-addon-spheres-module__7rU83q__product",
  "productLogo": "nav-addon-spheres-module__7rU83q__productLogo",
  "products": "nav-addon-spheres-module__7rU83q__products",
  "sphere": "nav-addon-spheres-module__7rU83q__sphere",
  "sphereCanvas": "nav-addon-spheres-module__7rU83q__sphereCanvas",
  "spherePoster": "nav-addon-spheres-module__7rU83q__spherePoster",
  "sphereVideoSource": "nav-addon-spheres-module__7rU83q__sphereVideoSource",
  "wrapper": "nav-addon-spheres-module__7rU83q__wrapper",
});
